<template>
  <v-container fluid class="px-8">
    <v-row>
      <v-col cols="3">
        <p class="label">Image</p>
        <div class="avatar-wrapper">
          <div class="upload-button">
            <img
              class="profile-pic"
              :src="getImage(this.form.thumbUrl)"
              v-if="this.form.thumbUrl"
            />
            <i class="fas fa-upload" @click="clickInputUpload"></i>
          </div>
          <input
            class="file-upload"
            @change="setFile($event.target.files)"
            ref="fileUpload"
            type="file"
            accept="image/*"
          />
        </div>
      </v-col>
      <v-col cols="6" offset="1">
        <ValidationObserver v-slot="{ handleSubmit }">
          <v-form v-on:submit.prevent="handleSubmit(save)">
            <v-row>
              <v-col class="px-0 py-0" cols="12">
                <v-card-text class="pa-0 mb-1">
                  <v-icon v-text="'far fa-clock'" class="mr-2 pl-3"></v-icon>
                  {{ form.date | moment("DD/MM/YYYY") }}
                </v-card-text>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  rules="required"
                  name="DegreeType"
                  v-slot="{ errors }"
                >
                  <v-radio-group
                    :error-messages="errors"
                    class="mt-1 px-0 py-0"
                    @change="getTopicsByDegreeType(), (form.topics = [])"
                    v-model="form.degreeType"
                    row
                  >
                    <v-row class="radio-group">
                      <v-col cols="6" class="px-0 py-0">
                    <v-radio
                                                 label="De Bac à Bac+3" :value="3"></v-radio>
                      </v-col>
                      <v-col cols="6" class="px-0 py-0">
                      <v-radio
                                                 label="De Bac+3 à Bac+6" :value="1"></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </ValidationProvider>
              </v-col>
              <v-col cols="6" class="mt--20">
                <ValidationProvider
                  rules="required"
                  name="Topic"
                  v-slot="{ errors }"
                >
                  <p class="label">Topic</p>
                  <v-autocomplete
                    v-model="form.topics"
                    :items="topics"
                    :disabled="!form.degreeType"
                    outlined
                    dense
                    chips
                    small-chips
                    multiple
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                  >
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
              <v-col cols="6" class="mt--20">
                <p class="label">Éditeur</p>
                <v-text-field
                  outlined
                  hide-details="auto"
                  v-model="form.author"
                  required
                  class="mb-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt--15">
                <ValidationProvider
                  rules="required"
                  name="Titre"
                  v-slot="{ errors }"
                >
                  <p class="label">Titre</p>
                  <v-text-field
                    outlined
                    hide-details="auto"
                    v-model="form.title"
                    required
                    class="mb-4"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="mt--15">
                <p class="label">Contenu</p>
                <textarea
                  id="ckeditor"
                  placeholder="Tapez votre textes…"
                  v-model="form.content"
                  rows="10"
                  cols="80"
                ></textarea>
              </v-col>
              <v-col cols="12" class="py-3">
                <v-btn
                  color="primary"
                  type="submit"
                  rounded
                  depressed
                  >Sauvegarder</v-btn
                >
                <v-btn
                  class="px-2 ml-3"
                  color="gray"
                  rounded
                  depressed
                  @click="cancel"
                  >Annuler</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import newsService from "@/services/news";
import topicService from "@/services/topic";
import { mapState } from "vuex";
export default {
  name: "NewsForm",
  props: {},
  data: () => ({
    file: null,
    reviewImage: "",
    topics: []
  }),
  created() {
    if (this.form.degreeType) {
      this.getTopicsByDegreeType();
    }
  },
  mounted() {
    // eslint-disable-next-line
    CKEDITOR.replace('ckeditor');
  },
  computed: {
    ...mapState({
      form: state => state.news.news
    })
  },
  methods: {
    clickInputUpload(event) {
      event.preventDefault();
      this.$refs.fileUpload.click();
    },
    async getTopicsByDegreeType() {
      let res = await topicService.getTopicsByDegreeType({
        degreeType: this.form.degreeType
      });
      if (res) {
        this.topics = res.data;
      }
    },
    setFile(files) {
      this.file = files[0];
      let form = JSON.parse(JSON.stringify(this.form));
      form.thumbUrl = URL.createObjectURL(files[0]);
      this.$store.dispatch("setNews", form);
    },
    async uploadFile() {
      if (!this.file) return;

      let formData = new FormData();
      formData.append("file", this.file);

      const res = await newsService.uploadFile(formData);
      if (res) {
        this.form.thumbUrl = res.data.url_file;
      }
    },
    cancel() {
      this.$store.dispatch("resetNews");
      this.$router.push({
        name: "News"
      });
    },
    async save() {
      await this.uploadFile();
      // eslint-disable-next-line
      this.form.content = CKEDITOR.instances.ckeditor.getData();
      if (this.form.id) {
        let res = await newsService.update(this.form);
        if (res) {
          this.$router.push({
            name: "News"
          });
        }
      } else {
        this.form.date = this.$moment(this.form.date).format("YYYY-MM-DD");
        let res = await newsService.create(this.form);
        if (res) {
          this.$router.push({
            name: "News"
          });
        }
      }
    }
  }
};
</script>
